export function allCapsToNormal(value: string): string {
  return value
    .split('_')
    .map((s) => `${s.substr(0, 1)}${s.substr(1).toLowerCase()}`)
    .join(' ');
}

export function isNullOrWhitespace(value: string | null | undefined): boolean {
  return value == null || value.trim() === '';
}

export function isValidInvoiceRoutingId(
  invoiceRoutingId: string | null | undefined,
) {
  if (isNullOrWhitespace(invoiceRoutingId)) {
    return true;
  }
  const regex = /^[A-Za-z0-9]+-[A-Za-z0-9]+(-[A-Za-z0-9]*)?$/;
  return regex.test(invoiceRoutingId || '');
}
